module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentImageName && _vm.currentImageName.length) ? _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.FILTER_METADATA), function(filterMetadata, filterType) {
    return _c('el-tab-pane', {
      key: filterType,
      attrs: {
        "label": filterMetadata.label,
        "name": filterType
      }
    }, [_c('el-slider', {
      staticClass: "slider-editor__slider",
      attrs: {
        "min": filterMetadata.range.min,
        "max": filterMetadata.range.max,
        "format-tooltip": _vm.formatTooltip(filterType),
        "show-input": ""
      },
      on: {
        "change": function($event) {
          _vm.onFilterChanged(filterType)
        }
      },
      model: {
        value: (_vm.currentFilters[filterType]),
        callback: function($$v) {
          _vm.$set(_vm.currentFilters, filterType, $$v)
        },
        expression: "currentFilters[filterType]"
      }
    })], 1)
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c30e106","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-filter/image-editor/slider-editor/slider-editor.vue
// module id = 291
// module chunks = 0